import { render, staticRenderFns } from "./exhibitor-boothMobile.vue?vue&type=template&id=924c26f2"
import script from "./exhibitor-boothMobile.vue?vue&type=script&lang=js"
export * from "./exhibitor-boothMobile.vue?vue&type=script&lang=js"
import style0 from "./exhibitor-boothMobile.vue?vue&type=style&index=0&id=924c26f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports